import React from 'react'
import { ThemeProvider as SCThemeProvider } from 'styled-components'
import { dark } from 'uikit'

const ThemeContext = React.createContext({ isDark: true, toggleTheme: () => null })

const ThemeContextProvider = ({ children }) => {
  return <SCThemeProvider theme={dark}>{children}</SCThemeProvider>
}

export { ThemeContext, ThemeContextProvider }
